import localStorageUtil from '@/utils/localStorageUtils'

export const isTestGroupA = () => {
  const localStorageKey = 'abTestGroup'
  let userTestGroup = localStorageUtil.get(localStorageKey)
  if (!userTestGroup) {
    userTestGroup = Math.random() < 0.5 ? "A" : "B"
    localStorageUtil.set(localStorageKey, userTestGroup)
  }
  return userTestGroup === "A"
}